import { useEffect, useRef } from "react";

import { analyticsService } from "../../../lib/analytics";
import type { EventTypes } from "../../../lib/analytics/types";

type HomeScreenViewedArgs = EventTypes["HomeScreenViewed"] & {
  /** Blocks the event until the screen's data has resolved. */
  loading: boolean;
};

// Fires HomeScreenViewed once per mount, the first time the screen finishes
// loading.
export function useHomeScreenViewedEvent({
  loading,
  casesShownCount,
  actionableCasesCount,
  unreadCasesCount,
  hasClosedWin,
}: HomeScreenViewedArgs): void {
  const fired = useRef(false);

  useEffect(() => {
    if (loading || fired.current) {
      return;
    }
    fired.current = true;
    analyticsService.trackEvent("HomeScreenViewed", {
      casesShownCount,
      actionableCasesCount,
      unreadCasesCount,
      hasClosedWin,
    });
  }, [
    loading,
    casesShownCount,
    actionableCasesCount,
    unreadCasesCount,
    hasClosedWin,
  ]);
}
